export default "__VITE_ASSET__CNyaLG5A__"